import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";
import { logout } from "../../store/authSlice";

const AutoLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector((state) => state.auth.token);
    const isAuthenticated = useSelector(
        (state) => state.auth.isAuthenticated
    );

    const [showModal, setShowModal] = useState(false);
    const [logoutType, setLogoutType] = useState("");

    // JWT Expiry Check
    useEffect(() => {
        if (!token || !isAuthenticated) return;

        const checkExpiration = () => {
            try {
                const decoded = jwtDecode(token);
                const exp = decoded.exp;

                if (exp && exp < Date.now() / 1000) {
                    dispatch(logout());
                    setLogoutType("session");
                    setShowModal(true);
                }
            } catch {
                dispatch(logout());
                navigate("/login");
            }
        };

        checkExpiration();

        const intervalId = setInterval(checkExpiration, 5000);

        return () => clearInterval(intervalId);
    }, [token, isAuthenticated, dispatch, navigate]);

    // Inactivity Logout
    useEffect(() => {
        if (!token || !isAuthenticated) return;

        let inactivityTimer;

        const resetTimer = () => {
            clearTimeout(inactivityTimer);

            inactivityTimer = setTimeout(() => {
                dispatch(logout());
                setLogoutType("inactivity");
                setShowModal(true);
            }, 24 * 60 * 60 * 1000); // 24 hours
        }; 


        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("click", resetTimer);
        window.addEventListener("keydown", resetTimer);
        window.addEventListener("scroll", resetTimer);

        resetTimer();

        return () => {
            clearTimeout(inactivityTimer);

            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("click", resetTimer);
            window.removeEventListener("keydown", resetTimer);
            window.removeEventListener("scroll", resetTimer);
        };
    }, [token, isAuthenticated, dispatch]);

    const handleLogout = () => {
        setShowModal(false);
        dispatch(logout());
        localStorage.clear();
        window.location.href = "/login";
    };

    const handleCloseModal = () => {
        setShowModal(false);
        window.location.href = "/home";
    };

    if (!showModal) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
            
        >
            <div
                className="bg-white rounded shadow p-4"
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    borderRadius: "12px",
                    position: "relative",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                { <button
                    onClick={handleCloseModal}
                    className="close-btn"
                >
                    ✕
                </button> }

                <div className="text-center mb-4">
                    <div
                        className="d-inline-flex justify-content-center align-items-center"
                        style={{
                            backgroundColor: "#ffe5e7",
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                        }}
                    >
                        <FaExclamationTriangle
                            style={{
                                color: "#28a745",
                                fontSize: "26px",
                            }}
                        />
                    </div>
                </div>

                <h4
                    className="text-center"
                    style={{
                        fontSize: "22px",
                        letterSpacing: "0.5px",
                    }}
                >
                    {logoutType === "inactivity"
                        ? "Logged Out"
                        : "Session Expired"}
                </h4>

                <p
                    className="text-center text-muted mb-4"
                    style={{
                        fontSize: "14px",
                        lineHeight: "1.6",
                    }}
                >
                    {logoutType === "inactivity"
                        ? "You were logged out due to long inactivity."
                        : "Your session has ended. Please log in again to continue."}
                </p>

                <div className="text-center">
                    <button
                        onClick={handleLogout}
                        className="btn btn-success btn-lg w-100"
                        style={{
                            fontFamily: "Italic, sans-serif",
                            fontSize: "20px",
                            padding: "10px",
                            borderRadius: "8px",
                        }}
                    >
                        Login Again
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AutoLogout;
